import { ArticleItemProps } from "./constants";
import Image from 'next/image';
import Link from 'next/link';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


interface MainBannerProps {
  banners: Array<ArticleItemProps>
}

const MainBanner = (props: MainBannerProps) => {
  const { banners } = props;

  return (
    <div className="mb-6">
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        loop={true}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        speed={1200}
        modules={[Autoplay]}
        className="mamapedia-main-banner"
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={index}>
            <Link href={`/mamapedia/${banner.slug}`}>
              <div className="relative pb-24 md:pb-0">
                <Image
                  src={banner.main_image}
                  alt={banner.title}
                  quality={100}
                  width={1200}
                  height={800}
                  className="object-cover w-full"
                />
                <div className="container absolute md:hidden bottom-6">
                  <div className="p-4 bg-white rounded-lg shadow-md">
                    <div className="flex items-center mb-2 space-x-2">
                      <Image
                        src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/pencil.png"}
                        alt="category icon"
                        quality={100}
                        width={14}
                        height={14}
                      />
                      <p className="text-xs text-mooimom">{banner.category}</p>
                    </div>
                    <p className="text-black font-bold text-base leading-6 text-ellipsis line-clamp-2 h-12">{banner.title}</p>
                  </div>
                </div>
                <div className="hidden mt-4 md:block">
                  <p className="text-xl font-semibold text-black">{banner.title}</p>
                  <div className="flex items-center mt-2 space-x-2">
                      <Image
                        src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/pencil.png"}
                        alt="category icon"
                        quality={100}
                        width={16}
                        height={16}
                      />
                      <p className="text-xs text-mooimom">{banner.category}</p>
                    </div>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default MainBanner
